<template>
   <div class="gallery_container bg_white box_shadow bottom">
        <div class="info_title">Gallery</div>
    <v-layout>
    <v-flex >
      <v-card>
        <v-container grid-list-sm fluid v-if="consultancy.galleries.length > 0">
          <v-layout row wrap>
            <v-flex v-for="(gallery, index) in consultancy.galleries " :key="index" xs4 d-flex >
              <v-card flat tile class="d-flex">
                <v-img :src="gallery.image" aspect-ratio="1" class="grey lighten-2">
                </v-img>
              </v-card>
            </v-flex>
          </v-layout>
        </v-container>
        <span v-else>No content Available</span>
      </v-card>
    </v-flex>
  </v-layout>
</div>

</template>

<script>
import {mapGetters} from 'vuex';
export default {
    computed: {
        ...mapGetters(['consultancy']),
    }
}
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/components/ConsultancyProfile/_gallery.vue